<template>
  <v-card v-if="addReltype">
    <v-card-title>Добавить&nbsp;<strong>{{addReltype | translate('v')}}</strong>&nbsp;для&nbsp;<strong>{{person.surname}}&nbsp;{{person.name}}&nbsp;{{person.midname}}</strong></v-card-title>
    <v-card-text>

			<v-checkbox label="приемный(ая)/отданный(ая)" v-model="adopted" color="primary"></v-checkbox>

			<v-autocomplete
        v-if="potentialItems.length !== 0"
        :items="potentialItems"
        v-model="personKeyToRelate"
        label="Выбрать"
        item-text="name"
        item-value="_key"
        menu-props="auto"
        dense
				clearable
      ></v-autocomplete>

			<v-form ref="addPersonForm" v-model="valid" v-if="!personKeyToRelate && !relateWithPicked">
				<person-fields :person="newPerson"></person-fields>
			</v-form>

      <v-checkbox
        v-if="showRelateWithPicked"
        :label="`соединить с: ${$options.filters.fullestName(pickedPerson)}`"
        v-model="relateWithPicked"
        color="primary"
      ></v-checkbox>
    </v-card-text>

    <v-card-actions>
      <v-btn
        @click.stop="submitRelate"
        class="primary"
        :disabled="loading || (!personKeyToRelate && !relateWithPicked)"
        :loading="loading"
      >
        Соединить
        <span slot="loader" class="custom-loader">
          <v-icon light>cached</v-icon>
        </span>
      </v-btn>

			<v-btn @click.stop="submitAddPerson" class="primary"
				:disabled="loading || personKeyToRelate || relateWithPicked" :loading="loading"
			>
				Добавить {{addReltype | translate('v')}}
			</v-btn>

      <v-spacer></v-spacer>

      <v-btn @click.stop="closeAddPersonDialog()">Отмена</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import axiosInst from "@/utils/axios-instance";
import { translate, fullestName } from "@/filters";

export default {
  data() {
    return {
      adopted: false,
      personKeyToRelate: null, // _key
			relateWithPicked: false,
			newPerson: {
				gender: ['mother', 'daughter'].includes(this.addReltype) ? 0 : 1
			},
      valid: true
    };
  },
	watch: {
    // Watch for dialog opening
    'addPersonDialog'(newVal) {
      if (newVal) {
				this.personKeyToRelate = null;
				this.relateWithPicked = false;
				this.adopted = false;
        this.newPerson = {
					gender: ['mother', 'daughter'].includes(this.addReltype) ? 0 : 1
				};
      }
    }
  },
  computed: {
		addPersonDialog: {
      get() {
        return this.$store.state.addPersonDialog;
      }
    },
		addReltype: {
			get() {
				return this.$store.state.addReltype;
			},
			set(value) {
				this.$store.state.addReltype = value;
			}
		},
    person() {
      return this.$store.state.person;
    },
    pickedPerson() {
      return this.$store.state.pickedPerson;
    },
		showRelateWithPicked() {
			if (!this.pickedPerson) return false;
			if (this.pickedPerson._id === this.person._id) return false;
			if (this.addReltype === 'father' || this.addReltype === 'son') {
				if (this.pickedPerson.gender === 0) return false;
			}
			if (this.addReltype === 'mother' || this.addReltype === 'daughter') {
				if (this.pickedPerson.gender === 1) return false;
			}
			return true;
		},
    potential() {
      return this.$store.state.potential;
    },
    loading() {
      return this.$store.state.loading;
    },
    rules() {
      return this.$store.state.rules;
    },
		potentialItems() {
			switch (this.addReltype) {
				case 'father': return this.potential.parents.filter(p => p.gender === 1); break;
				case 'mother': return this.potential.parents.filter(p => p.gender === 0); break;
				case 'son': return this.potential.children.filter(p => p.gender === 1); break;
				case 'daughter': return this.potential.children.filter(p => p.gender === 0); break;
			}
		}
  },
  methods: {
		closeAddPersonDialog() {
			this.$store.state.addPersonDialog = false;
			this.addReltype = null;
		},
    submitRelate() {
      let from_key, to_key;

			if (this.relateWithPicked) this.personKeyToRelate = this.pickedPerson._key;

			switch (this.addReltype) {
				case 'son':
				case 'daughter':
					from_key = this.person._key;
					to_key = this.personKeyToRelate;
					break;
				case 'father':
				case 'mother':
					from_key = this.personKeyToRelate;
					to_key = this.person._key;
					break;
			}

      axiosInst
        .post("/api/child/set_relation", {
          from_key,
          to_key,
          adopted: this.adopted
        })
        .then(resp => {
					this.closeAddPersonDialog();
          this.$emit("personAdded");
        })
        .catch(error => {
          this.$store.dispatch("axiosErrorHandle", error);
        });
    },
		submitAddPerson () {
      if (this.$refs.addPersonForm.validate()) {
        axiosInst.post(`/api/person/${this.person._key}/add/${this.$store.state.addReltype}`, {
          personData: this.newPerson,
          adopted: this.adopted
        })
        .then(resp => {
          this.closeAddPersonDialog();
          this.$emit("personAdded");
        })
        .catch(error => {this.$store.dispatch('axiosErrorHandle', error)})
      }
		}
  },
  filters: {
    translate
  }
};
</script>
